import axios from 'axios';
import type { TemplateUsage } from '@bb/domain/dist/types';

const listNames = async () => {
  const { data } = await axios.get<Record<TemplateUsage, string[]>>(
    '/template/list_names',
  );
  return data;
};

export default listNames;
